import { useState, useEffect } from "react"
import request from "../helpers/request"
import Container from '../components/container/container'
import Footer from '../components/footer/footer'
import Navigation from '../components/navigation/navigation'
import PageTitle from '../components/page-header/pageTitle'


export default function MaintenancePage() {
    const [maintenanceData, setMaintenanceData] = useState(null);

    useEffect(() => {
        request(true).get('/self').then(r => {
            window.location.href = '/login';
        }).catch(error => {
            console.log(error)
            if (error.status === 503 && error.data) {
                setMaintenanceData(error.data);
            }
        })
    }, [])

    return (
        <div className="grid grid-gap-15" style={{ minHeight: '100vh', gridTemplateRows: 'auto auto 1fr auto' }}>
            <Navigation />
            <Container>
                <PageTitle 
                    iconClass={"fak fa-solid fa-wrench fa-2x colour-primary"}
                    title={"Site Under Maintenance"}
                />
            </Container>
            <Container>
                <div style={{ display: 'grid', justifyContent: 'center', minHeight: '0vh' }}>
                    <div>
                        <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: maintenanceData?.message ?? "The site is currently under maintenance but should be available again soon." }}></p>
                        {
                            maintenanceData?.end_date &&
                                <p>
                                    {
                                        `It'll be available again on 
                                        ${new Date(maintenanceData.end_date).toLocaleDateString()}
                                        at
                                        ${new Date(maintenanceData.end_date).toLocaleTimeString()}`
                                    }
                                </p>
                        }
                    </div>
                </div>
            </Container>
            <Footer />
        </div>
    )
}